/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import _ from 'lodash';
import DataSnippets from '@components/data-snippet';
import RunRtTag from '@components/run-rt';
import TaskStatusAndPriority from '@components/task-status-priority';
import AssignmentBody from './card-body/assignment';
import BodyDescription from './card-body/body-description';
import CardFooter from './card-footer';
import CardHeader from './card-header';
import HighlightText from '@components/highlight-text';
import CardAsset from './card-asset';

import style from './task.module.scss';
import AdditionalData from '@components/additional-data';

const TaskCardNew = ({
  id,
  taskHeaderIconName,
  taskCardHeaderTitle,
  taskStatus,
  cardCheckbox = true,
  type,
  link,
  taskDescription,
  taskCardWorkStatus,
  taskCardUsers,
  rtInterval,
  moc,
  hse = false,
  equipmentsAsset,
  sitesAsset,
  priority,
  rtData,
  runData,
  taskFooter,
  syncedIcon,
  title,
  selected,
  setSelected,
  highlight,
  openModal,
  mocData,
  hseData,
  structureData,
  ncrData,
  pipelineData,
  primaryAssetType,
  dataPoints = [],
  sitesAssetFilterData,
  equipmentAssetFilterData,
  syncDateCustom = null,
  detailInspectionsInfo = {},
  inspectionType,
  chip,
  formWrapper = false,
  structureAsset,
  pipelineAsset,
  equipmentRecord = false,
  isNew = false,
  tasksDescriptionWIthHTMLTags = null,
  hasUTData = false,
  hasUTDataDownload = false,
  utDataDownloadedButImagesAreFailed = false
}) => {
  const [showUsers, setShowUsers] = useState(false);

  return (
    <div
      className={style.taskCardMain}
      style={{
        backgroundColor:
          taskStatus === 'Synced'
            ? '#E3E7EB'
            : taskStatus === 'Done'
            ? '#E3E7EB'
            : selected && '#D5E6FB'
      }}
      id="task-card-main"
    >
      <div className={style.taskCardHeader}>
        <CardHeader
          selected={selected}
          setSelected={setSelected}
          iconName={taskHeaderIconName || 'check-task'}
          title={taskCardHeaderTitle || 'title'}
          status={taskStatus}
          checkbox={cardCheckbox}
          syncedIcon={syncedIcon ? true : false}
          type={type}
          link={link}
          highlight={highlight}
          openModal={openModal}
          formWrapper={formWrapper}
        />
      </div>

      {(title || inspectionType) && (
        <div className={style.taskCardTitle} id="title">
          <span>
            <HighlightText
              text={type === 'Inspection' || type === 'HSE' ? inspectionType : title}
              highlight={highlight}
            />
          </span>
        </div>
      )}

      {(type === 'Inspection' || type === 'HSE' || type === 'Check') && taskDescription && (
        <div
          className={style.taskCardInner}
          style={{
            marginBottom: '0px'
          }}
        >
          <div className="mt-4">
            <BodyDescription description={taskDescription} highlight={highlight} />
          </div>
        </div>
      )}

      <div className={style.taskCardInner}>
        {/* dynamic */}
        <div className="mb-4">
          {dataPoints?.map(({ Id, value }, ind) => (
            <React.Fragment key={ind}>
              {Id === 'Description' && tasksDescriptionWIthHTMLTags && (
                <div style={{ margin: '16px 0' }}>
                  <BodyDescription
                    description={tasksDescriptionWIthHTMLTags}
                    highlight={highlight}
                  />
                </div>
              )}

              {!formWrapper && (
                <>
                  {Id === 'Status' && taskCardWorkStatus && (
                    <>
                      {
                        <div
                          style={{
                            marginTop: type === 'New or edited asset' ? '0px' : '16px',
                            marginBottom: type === 'New or edited asset' ? '16px' : '0px'
                          }}
                        >
                          <AssignmentBody
                            iconName={'activity'}
                            text={taskCardWorkStatus}
                            highlight={highlight}
                          />
                        </div>
                      }
                    </>
                  )}
                  {(Id === 'ResponsibleUsers' || Id === 'Inspectors') && (
                    <>
                      {_.size(taskCardUsers) > 0 && (
                        <div
                          onClick={(e) => {
                            if (!showUsers && taskCardUsers.length > 1) {
                              e.stopPropagation();
                              setShowUsers((prev) => !prev);
                            }
                          }}
                        >
                          {showUsers ? (
                            <div style={{ marginTop: '16px' }}>
                              <AssignmentBody
                                iconName={'users'}
                                assignmentData={taskCardUsers}
                                onClick={() => setShowUsers(false)}
                                highlight={highlight}
                              />
                            </div>
                          ) : (
                            <div style={{ marginTop: '16px' }}>
                              <AssignmentBody
                                iconName={'users'}
                                text={taskCardUsers?.length > 0 ? taskCardUsers[0] : ''}
                                collapseableValue={
                                  taskCardUsers.length > 1 ? taskCardUsers.length - 1 : ''
                                }
                                highlight={highlight}
                              />
                            </div>
                          )}
                        </div>
                      )}
                    </>
                  )}
                  {(Id === 'Recurrence' || Id === 'Interval') && (rtInterval || value) && (
                    <>
                      {
                        <div style={{ marginTop: '16px' }}>
                          <AssignmentBody
                            iconName={'rotate'}
                            text={rtInterval || value}
                            highlight={highlight}
                          />
                        </div>
                      }
                    </>
                  )}
                  {Id === 'Type' && value && (
                    <>
                      {
                        <div style={{ marginTop: '16px' }}>
                          <AssignmentBody
                            iconName={'work-order-type'}
                            text={value}
                            highlight={highlight}
                          />
                        </div>
                      }
                    </>
                  )}

                  {Id === 'Identifier' && value && (
                    <>
                      {
                        <div style={{ marginTop: '16px' }}>
                          <AssignmentBody
                            iconName={'identifier-icon'}
                            text={value}
                            highlight={highlight}
                          />
                        </div>
                      }
                    </>
                  )}

                  {Id === 'Location' && value && (
                    <>
                      {
                        <div style={{ marginTop: '16px' }}>
                          <AssignmentBody
                            iconName={'location-icon'}
                            text={value}
                            highlight={highlight}
                          />
                        </div>
                      }
                    </>
                  )}
                </>
              )}
            </React.Fragment>
          ))}
        </div>
        {/* dynamic */}
        {hse && (
          <div className="mb-4">
            <DataSnippets
              title={hse?.title || ''}
              subtitle={hse?.subtitle || ''}
              iconName={'hse'}
              backFlex={style.backClass}
              highlight={highlight}
              className={style.mainClass}
            />
          </div>
        )}
        {/* asset details section start */}

        <CardAsset
          equipmentAssetFilterData={equipmentAssetFilterData}
          sitesAssetFilterData={type === 'HSE' ? sitesAsset : sitesAssetFilterData}
          mocData={mocData}
          hseData={hseData}
          structureData={structureData}
          ncrData={ncrData}
          pipelineData={pipelineData}
          highlight={highlight}
          detailInspectionsInfo={detailInspectionsInfo}
          chip={chip}
          formWrapper={formWrapper}
          structureAsset={structureAsset}
          pipelineAsset={pipelineAsset}
          id={id}
          noMarginTop={equipmentRecord}
          type={type}
          isNewEquipment={isNew}
        />
        {/* asset details section start */}
      </div>

      {(priority || rtData?.id || runData?.id) && (
        // add condition to add margin bottom
        <div className={`${!hasUTData && style['mb-16']} ${style.chipsDivNew} `}>
          {priority && <TaskStatusAndPriority status={priority} />}
          {rtData?.id && (
            <RunRtTag
              rtNumber={rtData?.id}
              rtName={rtData?.title ? rtData?.title : ''}
              selected={selected}
            />
          )}
          {runData?.id && (
            <RunRtTag
              rtNumber={runData?.id}
              rtName={runData?.title ? runData?.title : ''}
              selected={selected}
            />
          )}
        </div>
      )}

      {hasUTData && (
        <div className={style.chipsDiv}>
          {runData?.id && (
            <AdditionalData
              utDataDownloadedButImagesAreFailed={utDataDownloadedButImagesAreFailed}
              isDownloaded={
                // hasUTDataDownload
                utDataDownloadedButImagesAreFailed && hasUTDataDownload
                  ? false
                  : hasUTDataDownload
                  ? true
                  : false
              }
            />
          )}
        </div>
      )}

      <div className={style.taskCardFooter}>
        <CardFooter
          footerColor={taskFooter?.footerColor || '#2f80ed'}
          footerData={taskFooter?.dates || []}
          syncDateCustom={syncDateCustom}
        />
      </div>
    </div>
  );
};

export default React.memo(TaskCardNew, _.isEqual);
